import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { RoleArtifact } from 'src/app/core/models/role-artifacts.model';
import { AppConfigService } from 'src/app/core/services/app-config.service';
import { UtilService } from 'src/app/core/services/util.service';

@Component({
  selector: 'app-app-progress-dialog',
  templateUrl: './app-progress-dialog.component.html',
  styleUrls: ['./app-progress-dialog.component.scss']
})
export class AppProgressDialogComponent {

  outstanding = 0;
  completed = 0;
  total = 0;
  percent = 0;

  constructor(
    private appConfig: AppConfigService,
    private utilService: UtilService,
    public dialogRef: MatDialogRef<AppProgressDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public roleArtifacts: RoleArtifact[],
  ) { 
    console.log(roleArtifacts);
    this.calculate();
  }

  calculate(){
    this.roleArtifacts.map(i=>{
      this.outstanding += i.outstanding;
      this.completed += i.completed;
      i.artifacts = this.sortArtifacts(i.artifacts, i.role);
    })
    this.total = this.outstanding + this.completed;
    this.percent = Math.ceil(this.completed * 100 / this.total);
  }

  sortArtifacts(artifacts:any, role:string){
    return this.utilService.sortByArray(artifacts, this.appConfig.ARTIFACTS_ORDERS, (t)=>t.key)
  }



}
